module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10248.5f248f8e.jpg";